module.exports = "/_next/static/images/4ae1716ff11d3870b348c9a3c33975c9-slide2mobile.jpg.webp";